import { Observable } from "rxjs";
import { LetterheadBackend } from "src/app/backend/api/letterhead/letterhead.backend";
import {
  Letterhead,
  LetterheadLight
} from "src/app/backend/models/letterhead/letterhead";
import { LetterheadCreate } from "src/app/backend/models/letterhead/letterhead-create";
import { LetterheadUpdate } from "src/app/backend/models/letterhead/letterhead-update";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";

export class NotImplementedLetterheadBackend extends LetterheadBackend {
  load(id: string): Observable<Letterhead> {
    throw new Error("Method not implemented.");
  }
  loadLight(id: string): Observable<LetterheadLight> {
    throw new Error("Method not implemented.");
  }
  loadDefaultLight(): Observable<LetterheadLight | undefined> {
    throw new Error("Method not implemented.");
  }
  loadDefault(): Observable<Letterhead | undefined> {
    throw new Error("Method not implemented.");
  }
  list(request: PageRequest): Observable<PaginatedResult<Letterhead>> {
    throw new Error("Method not implemented.");
  }
  listAll(): Observable<Letterhead[]> {
    throw new Error("Method not implemented.");
  }
  listAllLight(): Observable<LetterheadLight[]> {
    throw new Error("Method not implemented.");
  }
  create(payload: LetterheadCreate): Observable<Letterhead> {
    throw new Error("Method not implemented.");
  }
  delete(id: string): Observable<void> {
    throw new Error("Method not implemented.");
  }
  update(id: string, payload: LetterheadUpdate): Observable<void> {
    throw new Error("Method not implemented.");
  }
}
